/**
 * ADR-0017: ціни зберігаються як цілі cents (integer). Ця утиліта — єдина
 * точка перетворення між рядковим введенням і cents, а також форматування для
 * відображення.
 */

/**
 * Перетворює рядок, введений користувачем, у cents.
 *
 * "800" → 80000, "800.00" → 80000, "0" → 0.
 * Відхиляє: порожній рядок, не-числові значення, 3+ десяткових знаки → NaN.
 */
export function parseAmountToCents(raw: string): number {
  if (raw === "") return NaN;
  // Дозволяємо лише цифри + не більше 2 десяткових.
  if (!/^\d+(\.\d{1,2})?$/.test(raw)) return NaN;
  return Math.round(parseFloat(raw) * 100);
}

/** cents → "€X.XX". 80000 → "€800.00", 0 → "€0.00". */
export function formatCents(cents: number): string {
  return `€${(cents / 100).toFixed(2)}`;
}

/**
 * 45 → "45 min", 0 → "0 min".
 * Intentionally locale-agnostic: утиліта поза Vue-контекстом, "min" — unit-рядок
 * для підстановки у шаблон. Локалізацію одиниць виконує компонент.
 */
export function formatMinutes(minutes: number): string {
  return `${minutes} min`;
}

/**
 * Гуманізована тривалість (uk): 45 → "45 хв", 60 → "1 год", 90 → "1 год 30 хв".
 */
export function formatDurationUk(minutes: number): string {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h === 0) return `${m} хв`;
  if (m === 0) return `${h} год`;
  return `${h} год ${m} хв`;
}
